import { useState } from 'react'
import { IconButton, Tooltip } from '@mui/material'
import { HelpOutline } from '@mui/icons-material'
import HelpDrawer from './HelpDrawer'

interface Props {
  /** ID of the article to render in the drawer (must exist in helpArticles.json) */
  articleId: string
  /** Tooltip text shown on hover. Defaults to "How does this page work?" */
  tooltip?: string
  /** Icon button size. Defaults to "small". */
  size?: 'small' | 'medium' | 'large'
  /** Drawer width on md+; mobile is always full-width. Defaults to HelpDrawer's 540. */
  drawerWidth?: number
}

/**
 * Standardized "what is this page" affordance: HelpOutline icon button that
 * opens HelpDrawer with a page-scoped article. Place next to the page title.
 * Reference impl: NorthStarTemplates.tsx, CompanyContext.tsx. See MWA-201.
 */
export default function PageHelpButton({
  articleId,
  tooltip = 'How does this page work?',
  size = 'small',
  drawerWidth,
}: Props) {
  const [open, setOpen] = useState(false)
  return (
    <>
      <Tooltip title={tooltip}>
        <IconButton
          onClick={() => setOpen(true)}
          size={size}
          aria-label="Open help drawer"
        >
          <HelpOutline />
        </IconButton>
      </Tooltip>
      <HelpDrawer
        articleId={articleId}
        open={open}
        onClose={() => setOpen(false)}
        width={drawerWidth}
      />
    </>
  )
}
